module.exports = {"pt-BR":{"admin":{"components":{"navbar":{"adminManagementIndex":"Gerenciamento"}}}}}